import type { IconData } from '@stacksjs/iconify-core'

export const contentConfirmFolder: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h4l2 2h8v4.875A5.5 5.5 0 0 0 6.59 13H0z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.15 8.168q.45.136.85.367a4 4 0 1 1-.85-.367M11.56 14l2.94-2.94L13.44 10l-1.88 1.879l-1-1l-1.06 1.06z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentConfirmFolder
